import { AUTHENTICATION } from "../constants/slices";
import { AuthTokenStateDefault } from "../states/authTokenState";
import { createSlice } from "@reduxjs/toolkit";

const authState = AuthTokenStateDefault;

const authSlice = createSlice({
  name: AUTHENTICATION,
  initialState: authState,
  reducers: {},
});

export default authSlice.reducer;
